import React from 'react';
import DeleteRoomModal from './modals/DeleteRoomModal';
import ReportMessageSpamModal from './modals/ReportMessageSpamModal';
import ReportSpamDoneModal from './modals/ReportSpamDoneModal';
import RenameRoomModal from './modals/RenameRoomModal';
import BannedUserModal from './modals/BannedUserModal';
import GroupOrChannelFullModal from './modals/GroupOrChannelFullModal';
import CreateGroupOrChannelModal from './modals/CreateGroupOrChannelModal';
import ReactionLimitModal from './modals/ReactionLimitModal';

export const MODAL_TYPES = {
  DELETE_ROOM: 'DELETE_ROOM',
  MESSAGE_SPAM: 'MESSAGE_SPAM',
  REPORT_SPAM_DONE: 'REPORT_SPAM_DONE',
  RENAME_ROOM: 'RENAME_ROOM',
  BANNED_USER_MODAL: 'BANNED_USER_MODAL',
  GROUP_OR_CHANNEL_FULL: 'GROUP_OR_CHANNEL_FULL',
  CREATE_GROUP_OR_CHANNEL: 'CREATE_GROUP_OR_CHANNEL',
  REACTION_LIMIT_MODAL: 'REACTION_LIMIT_MODAL',
};

/**
 * Make sure all modals are lazy loaded if adding new ones, this will be included in every
 * propjects main bundle otherwise.
 */
export const damzModalRenderer = (
  modalType: string,
  requestClose: () => void,
  params?: any
) => {
  switch (modalType) {
    case MODAL_TYPES.DELETE_ROOM:
      return (
        <DeleteRoomModal
          requestClose={requestClose}
          room_id={params.room_id}
          roomType={params.roomType}
          isOwner={params.isOwner}
          isDelete={params.isDelete}
        />
      );
    case MODAL_TYPES.CREATE_GROUP_OR_CHANNEL:
      return <CreateGroupOrChannelModal onRequestClose={requestClose} />;
    case MODAL_TYPES.MESSAGE_SPAM:
      return (
        <ReportMessageSpamModal
          requestClose={requestClose}
          message_id={params.message_id}
          room_id={params.room_id}
        />
      );
    case MODAL_TYPES.REPORT_SPAM_DONE:
      return (
        <ReportSpamDoneModal requestClose={requestClose} user={params.user} />
      );
    case MODAL_TYPES.RENAME_ROOM:
      return (
        <RenameRoomModal
          requestClose={requestClose}
          room_id={params.room_id}
          roomType={params.roomType}
          currentName={params.currentName}
        />
      );
    case MODAL_TYPES.BANNED_USER_MODAL:
      return (
        <BannedUserModal
          requestClose={requestClose}
          room_id={params.room_id}
          bannedUser={params.bannedUser}
        />
      );
    case MODAL_TYPES.GROUP_OR_CHANNEL_FULL:
      return (
        <GroupOrChannelFullModal
          requestClose={requestClose}
          roomType={params.roomType}
          isUpsell={params.isUpsell}
        />
      );
    case MODAL_TYPES.REACTION_LIMIT_MODAL:
      return <ReactionLimitModal requestClose={requestClose} />;
    default:
      return null;
  }
};

export default damzModalRenderer;
